import { ProductInfo, ProductVariant } from "@/types/AppTypes";

export const getDefaultParseVariants = (productInfos: ProductInfo[] = []) => {
  if (!productInfos || productInfos.length === 0) return [];

  return productInfos
    .map((product) => {
      const variants = (product?.variants || [])
        .map((v: any) => {
          try {
            return typeof v === "string" ? JSON.parse(v) : v;
          } catch (e) {
            console.error("Failed to parse variant JSON:", v);
            return null;
          }
        })
        .filter(Boolean);

      const defaultVariants = variants
        .filter((variant: ProductVariant) => variant?.show_by_default === true)
        .map((variant: ProductVariant) => ({
          ...variant,
          product_id: product?.id,
          seller_id: product?.seller_id,
          brand_id: product?.brand_id,
          category_id: product?.category_id,
          ...(variant?.name ? {} : { name: product?.name }),
        }));

      if (defaultVariants.length > 0) return defaultVariants;

      return variants.length > 0
        ? [
            {
              ...variants?.[0],
              product_id: product?.id,
              seller_id: product?.seller_id,
              brand_id: product?.brand_id,
              category_id: product?.category_id,
              ...(variants[0]?.name ? {} : { name: product?.name }),
            },
          ]
        : [];
    })
    .flat();
};
